document.addEventListener("DOMContentLoaded", function () {
    const currencySelect = document.querySelector("[data-currency-converter]");

    if (currencySelect) {
        currencySelect.addEventListener("change", function () {
            const selectedCurrency = currencySelect.value;
            changeCurrency(selectedCurrency);
        });
    }
});

function changeCurrency(currency) {
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            currency: currency
        })
    })
        .then(response => response.json())
        .then(data => {
            window.location.reload();
        })
        .catch(error => {
            console.error('Error changing currency:', error);
        });
}

document.addEventListener('DOMContentLoaded', () => {
    const menuBox = document.querySelector('.hn-megamenu-box-mdjhd.tab-menu');
    const contentBox = document.querySelector('.hn-list-mdjhd');
    let isListenerAttached = false;

    function resetStyles() {
        if (contentBox) {
            contentBox.style.display = '';
            contentBox.style.opacity = '';
            contentBox.style.transform = '';
            contentBox.style.transition = '';
        }
    }

    function handleMenuToggle() {
        const screenWidth = window.innerWidth;

        if (menuBox && contentBox) {
            if (screenWidth <= 1024) {
                contentBox.style.display = 'none';
                contentBox.style.opacity = '0';
                contentBox.style.transition = 'opacity 0.3s ease, transform 0.3s ease';

                if (!isListenerAttached) {
                    menuBox.addEventListener('click', toggleMenu);
                    isListenerAttached = true;
                }
            } else {
                resetStyles();
                if (isListenerAttached) {
                    menuBox.removeEventListener('click', toggleMenu);
                    isListenerAttached = false;
                }
            }
        }
    }

    function toggleMenu() {
        if (contentBox.style.display === 'none' || contentBox.style.display === '') {
            contentBox.style.display = 'flex';
            setTimeout(() => {
                contentBox.style.opacity = '1';
                contentBox.style.transform = 'translateY(0)';
            }, 10);
        } else {
            contentBox.style.opacity = '0';
            contentBox.style.transform = 'translateY(-10px)';
            setTimeout(() => {
                contentBox.style.display = 'none';
            }, 300);
        }
    }

    handleMenuToggle();

    window.addEventListener('resize', handleMenuToggle);
});


document.addEventListener('DOMContentLoaded', function () {
    var hasChildElements = document.querySelectorAll('.hn-has-child-mdjhd');

    function handleToggle() {
        var screenWidth = window.innerWidth;
        if (screenWidth <= 1024) {
            hasChildElements.forEach(function (element) {
                element.addEventListener('click', function () {
                    var submenu = element.querySelector('.hn-nav-submenu-mdjhd');
                    var parentItem = element.querySelector('.hn-nav-item-mdjhd');

                    if (submenu) {
                        var currentDisplay = window.getComputedStyle(submenu).display;
                        if (currentDisplay === 'none') {
                            submenu.style.display = 'block';
                            if (parentItem) {
                                parentItem.classList.add('active');
                            }
                        } else {
                            submenu.style.display = 'none';
                            if (parentItem) {
                                parentItem.classList.remove('active');
                            }
                        }
                    }
                });
            });
        }
    }

    handleToggle();

    window.addEventListener('resize', function () {
        handleToggle();
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var hasChildElementsFirst = document.querySelectorAll('.hnsm-has-child-mdjhd');
    var hasNewContentBox = document.querySelectorAll('.hn-dd-tsm-mdjhd');
    var hasChildElementsSecond = document.querySelectorAll('.htnsm-has-child-mdjhd');

    function handleChildToggle() {
        var screenWidth = window.innerWidth;

        if (screenWidth <= 1024) {
            hasChildElementsFirst.forEach(function (element) {
                element.addEventListener('click', function () {
                    toggleSubmenu(element, '.hn-dd-ssm-mdjhd');
                    toggleActiveClass(element);
                });
            });

            hasNewContentBox.forEach(function (element) {
                element.addEventListener('click', function () {
                    toggleSubmenu(element, '.hn-dd-tsm-mdjhd');
                    toggleActiveClass(element);
                });
            });

            hasChildElementsSecond.forEach(function (element) {
                element.addEventListener('click', function (event) {
                    event.stopPropagation();
                    toggleSubmenu(element, '.hn-dd-tsm-mdjhd');
                    toggleActiveClass(element);
                });
            });
        } else {
            resetSubmenuDisplay([hasChildElementsFirst, hasNewContentBox, hasChildElementsSecond]);
        }
    }

    function toggleSubmenu(element, submenuSelector) {
        var submenu = element.querySelector(submenuSelector);
        if (submenu) {
            var currentDisplay = window.getComputedStyle(submenu).display;
            submenu.style.display = currentDisplay === 'none' ? 'block' : 'none';
        }
    }

    function resetSubmenuDisplay(elementsGroups) {
        elementsGroups.forEach(function (group) {
            group.forEach(function (element) {
                var submenus = element.querySelectorAll('ul, div');
                submenus.forEach(function (submenu) {
                    submenu.style.display = '';
                });
            });
        });
    }

    function toggleActiveClass(element) {
        if (element.classList.contains('active')) {
            element.classList.remove('active');
            element.classList.add('inactive');
        } else {
            element.classList.remove('inactive');
            element.classList.add('active');
        }
    }

    handleChildToggle();

    window.addEventListener('resize', function () {
        handleChildToggle();
    });
});

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
        var elements = document.querySelectorAll('.hn-db-inner-mdjhd .hn-dbi-prime-mdjhd');

        elements.forEach(function (element) {
            element.addEventListener('click', function (e) {
                e.stopPropagation();
                var parent = this.closest('.hn-db-inner-mdjhd');
                var target = parent.querySelector('.hn-dd-submenu-mdjhd');

                if (target) {
                    if (target.classList.contains('active')) {
                        target.classList.remove('active');
                        target.classList.add('inactive');
                    } else {
                        target.classList.remove('inactive');
                        target.classList.add('active');
                    }

                    if (parent.classList.contains('active')) {
                        parent.classList.remove('active');
                        parent.classList.add('inactive');
                    } else {
                        parent.classList.remove('inactive');
                        parent.classList.add('active');
                    }
                }
            });
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const showMenuTrigger = document.querySelectorAll('.mobile-megamenu-mdjhd');
    const hideMenuTrigger = document.querySelectorAll('.mobile-megamenu-ci-mdjhd');
    const mobileMenu = document.querySelector('.mobile-menu-mdjhd');
    const mobileHeaderTop = document.querySelector('.mobile-header-mdjhd .header-top-mdjhd');
    const mobileHeader = document.querySelector('.mobile-header-mdjhd');
    const mainHeader = document.querySelector('.main-header-mdjhd');
    const mobileSearchArea = document.querySelector('.mobile-search-area');
    const htsBoxMdjhd = document.querySelectorAll('.hts-box-inner-mdjhd.work-for-me');
    const mobileSearchAreaClose = document.querySelector('.mobile-search-area-close');
    const mainHeader_mdksd = document.querySelector('.mobile-menu-bottom-mdjhd');

    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY || window.pageYOffset;
        if (scrollY > 100) {
            mobileHeaderTop.style.display = 'block';
            mainHeader_mdksd.style.display = 'block';
        } else {
            mobileHeaderTop.style.display = 'none';
            mainHeader_mdksd.style.display = 'none';
        }
    });

    mobileHeaderTop.style.display = 'none';
    mainHeader_mdksd.style.display = 'none';

    if (mobileSearchArea) {
        mobileSearchArea.style.display = 'none';
        mobileSearchArea.style.opacity = 0;
        mobileSearchArea.style.transform = 'translateY(100%)';
        mobileSearchArea.style.transition = 'opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1), transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';

        htsBoxMdjhd.forEach(trigger => {
            trigger.addEventListener('click', function () {
                mobileMenu.style.opacity = 0;
                mobileMenu.style.transform = 'translateY(100px)';

                setTimeout(() => {
                    mobileSearchArea.style.display = 'block';
                    document.body.classList.add('mobile-menu-active');
                    mobileMenu.style.display = 'none';
                    mobileHeaderTop.style.display = 'block';
                    mainHeader.style.display = 'block';
                    mobileHeader.style.height = 'unset';
                    mobileHeader.style.position = 'fixed';
                    mobileHeader.style.top = 'unset';
                    mobileHeader.style.bottom = '0';

                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    mobileSearchArea.style.opacity = 1;
                    mobileSearchArea.style.transform = 'translateY(0)';
                }, 10);

                mainHeader_mdksd.style.zIndex = 'unset';
            });
        });

        mobileSearchAreaClose.addEventListener('click', function () {
            mobileSearchArea.style.opacity = 0;
            mobileSearchArea.style.transform = 'translateY(100%)';

            setTimeout(() => {
                document.body.classList.remove('mobile-menu-active');
                mobileSearchArea.style.display = 'none';
            }, 200);
        });
    }

    if (showMenuTrigger.length > 0 && hideMenuTrigger.length > 0 && mobileMenu) {
        mobileMenu.style.display = 'none';
        mobileMenu.style.opacity = 0;
        mobileMenu.style.transform = 'translateY(100px)';
        mobileMenu.style.transition = 'opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1), transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';

        showMenuTrigger.forEach(trigger => {
            trigger.addEventListener('click', function () {
                mobileMenu.style.display = 'block';
                mobileHeaderTop.style.display = 'none';
                mainHeader.style.display = 'none';
                mobileHeader.style.height = '100vh';
                mobileHeader.style.position = 'absolute';
                mobileHeader.style.top = '0';
                mobileHeader.style.bottom = 'unset';

                setTimeout(() => {
                    document.body.classList.add('mobile-menu-active');
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    mobileMenu.style.opacity = 1;
                    mobileMenu.style.transform = 'translateY(0)';
                }, 10);
                mainHeader_mdksd.style.display = 'block';
                mainHeader_mdksd.style.zIndex = '99';
            });
        });

        hideMenuTrigger.forEach(trigger => {
            trigger.addEventListener('click', function () {
                mobileMenu.style.opacity = 0;
                mobileMenu.style.transform = 'translateY(100px)';

                setTimeout(() => {
                    document.body.classList.remove('mobile-menu-active');
                    mobileMenu.style.display = 'none';
                    mobileHeaderTop.style.display = 'block';
                    mainHeader.style.display = 'block';
                    mobileHeader.style.height = 'unset';
                    mobileHeader.style.position = 'fixed';
                    mobileHeader.style.top = 'unset';
                    mobileHeader.style.bottom = '0';
                }, 200);

                mainHeader_mdksd.style.zIndex = 'unset';
            });
        });

    }
});

document.addEventListener("DOMContentLoaded", function () {
    const titles = document.querySelectorAll(".mobile-menu-title-mdjhd");
    const contents = document.querySelectorAll(".mm-nav-content-mdjhd");

    if (contents.length > 0) {
        contents[0].style.setProperty('display', 'block', 'important');
        titles[0].classList.add("mm-active");
    }

    titles.forEach((title, index) => {
        title.addEventListener("click", () => {
            titles.forEach((t, titleIndex) => {
                if (titleIndex === index) {
                    t.classList.add("mm-active");
                    t.classList.remove("mm-inactive");
                } else {
                    t.classList.remove("mm-active");
                    t.classList.add("mm-inactive");
                }
            });

            contents.forEach((content, contentIndex) => {
                if (contentIndex === index) {
                    content.style.setProperty('display', 'block', 'important');
                } else {
                    content.style.setProperty('display', 'none', 'important');
                }
            });
        });
    });

});

document.addEventListener('DOMContentLoaded', function () {
    var elements = document.querySelectorAll('.hn-dds-fsl-mdjhd .hnsm-has-child-mdjhd');

    elements.forEach(function (element) {
        element.addEventListener('click', function () {
            var target = this.querySelector('.hn-dd-dtsm-mdjhd');

            if (target) {
                target.classList.toggle('active');
            }
        });
    });
});
